import { render } from "./LearningGoalTaskDetailComponent.vue?vue&type=template&id=a8d84416&scoped=true"
import script from "./LearningGoalTaskDetailComponent.vue?vue&type=script&lang=js"
export * from "./LearningGoalTaskDetailComponent.vue?vue&type=script&lang=js"

import "./LearningGoalTaskDetailComponent.vue?vue&type=style&index=0&id=a8d84416&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d84416"]])

export default __exports__